"use strict";

var _slicedToArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var keywords_editor_module_scss_1 = __importDefault(require("./keywords-editor.module.scss"));

var styled_chip_input_component_1 = __importDefault(require("./styled-chip-input.component"));

var core_1 = require("@material-ui/core");

var custom_chip_component_1 = __importDefault(require("./custom-chip.component"));

var Fab_1 = __importDefault(require("@material-ui/core/Fab"));

var Add_1 = __importDefault(require("@material-ui/icons/Add"));

var KeywordsEditor = function KeywordsEditor(_ref) {
  var keywords = _ref.keywords,
      handleAddKeyword = _ref.handleAddKeyword,
      handleRemoveKeyword = _ref.handleRemoveKeyword,
      validate = _ref.validate;
  var inputRef = react_1.useRef(null);

  var _react_1$useState = react_1.useState(''),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      errorMessage = _react_1$useState2[0],
      setErrorMessage = _react_1$useState2[1];

  var _react_1$useState3 = react_1.useState(''),
      _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
      value = _react_1$useState4[0],
      setValue = _react_1$useState4[1];

  var onIconClick = function onIconClick() {
    if (!inputRef.current) return;
    inputRef.current.focus();
  };

  var onAdd = function onAdd(keyword) {
    if (errorMessage) return;
    handleAddKeyword(keyword);
    setTimeout(function () {
      return setValue('');
    }, 0); // IME 対策 (ENTER を押しても IME 時だと value が残ってしまう）
  };

  var onUpdateInput = function onUpdateInput(e) {
    var keyword = e.currentTarget.value;
    setErrorMessage('');
    setValue(keyword);

    var _validate = validate(keyword),
        error = _validate.error;

    if (error) setErrorMessage(error);
  };

  return react_1.default.createElement(core_1.Fade, {
    in: true,
    timeout: 500
  }, react_1.default.createElement("div", {
    className: keywords_editor_module_scss_1.default.container
  }, react_1.default.createElement("section", {
    className: keywords_editor_module_scss_1.default.titleSection
  }, react_1.default.createElement("h1", {
    className: keywords_editor_module_scss_1.default.title
  }, "\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u8FFD\u52A0"), react_1.default.createElement(Fab_1.default, {
    variant: "extended",
    size: "small",
    "aria-label": "add",
    style: {
      backgroundColor: 'var(--color-orange)',
      color: '#fff'
    },
    onClick: onIconClick
  }, react_1.default.createElement(Add_1.default, null))), react_1.default.createElement("section", {
    className: keywords_editor_module_scss_1.default.chipSection
  }, react_1.default.createElement(styled_chip_input_component_1.default, {
    ref: inputRef,
    value: keywords,
    onAdd: onAdd,
    inputValue: value,
    onUpdateInput: onUpdateInput,
    // variable を parse するために独自の chip component を使用
    chipRenderer: function chipRenderer(_ref2) {
      var value = _ref2.value;
      return react_1.default.createElement(custom_chip_component_1.default, {
        key: value,
        keyword: value,
        onDeleteClick: function onDeleteClick(e) {
          e.stopPropagation();
          handleRemoveKeyword(value);
        }
      });
    }
  })), errorMessage && react_1.default.createElement("p", {
    className: keywords_editor_module_scss_1.default.errorMessage
  }, errorMessage)));
};

exports.default = KeywordsEditor;